module.exports = __webpack_public_path__ + "static/Jolie.b983d552.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Jolie.jpg
// module id = 1301
// module chunks = 137408898365125